import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Loader from "../components/Loader";
import useAuth from "../hooks/useAuth";

const PublicRoute = () => {
  const { isLoggedIn, gettingMe } = useAuth();

  if (gettingMe) return <Loader />;
  if (isLoggedIn) return <Navigate to="/jobs/current" />;

  return <Outlet />;
};

export default PublicRoute;
